import { useState } from 'react';

import Button from '@mui/material/Button';

export const NewButton = ({ name, link, color, bgColor, borderColor, fontSize }) => {
   const [classes, setClasses] = useState('box')
   const [brightness, setBrightness] = useState("100%")
   return (
      <a href={link} style={{ display: 'inline-flex', width: '100%', justifyContent: 'center', alignItems: "center" }}>
         <Button
            endIcon={
               <img alt='chevron' src={"./assets/media/chevron.png"} className={classes} />
            }
            onMouseEnter={() => { setClasses('box bounce-1'); setBrightness("90%") }}
            onMouseLeave={() => { setClasses('box'); setBrightness("100%") }}
            sx={{
               display: "inline-flex",
               border: `1px solid ${borderColor}`,
               height: "100%",
               borderRadius: "25px",
               color: `${color} !important`,
               fontWeight: "900",
               backgroundColor: `${bgColor} !important`,
               opacity: 1,
               width: '70%',
               fontSize: fontSize,
               justifyContent: 'center',
               alignItems: 'center',
               filter: `brightness(${brightness})`,
               padding: '3.5% 0%',
               webkitBoxShadow: " 9px 9px 5px -4px rgba(0,0,0,0.45)",
               mozBoxShadow: " 9px 9px 5px -4px rgba(0,0,0,0.45)",
               boxShadow: " 9px 9px 5px -4px rgba(0,0,0,0.45)",
            }}
         >
            <span style={{ filter: 'brightness(100%) !important' }}>{name}</span>
         </Button>
      </a>
   );
};
